// ModeSwitchButtons.js
// 从 App.js 抽取出的「学单词 / 学用法 / 学句子」模式切换按钮组
// 切换前需要做的音频清理逻辑（学单词/学用法页要停止发音循环，学句子页要停止句子循环播放）
// 由调用方通过 onSwitch 回调自行处理，本组件只负责渲染和触发切换

import React from 'react';

function ModeSwitchButtons({ studyMode, currentTheme, onSwitch }) {
  const baseButtonStyle = {
    padding: '6px 16px',
    borderRadius: '20px',
    fontSize: '0.85em',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    transition: 'all 0.2s',
  };

  return (
    <div style={{ display: 'flex', justifyContent: 'center', gap: '8px', flexWrap: 'wrap' }}>
      <button
        onClick={() => onSwitch('word')}
        style={{
          ...baseButtonStyle,
          border: studyMode === 'word' ? 'none' : `1px solid ${currentTheme.border}`,
          background: studyMode === 'word' ? '#1890ff' : 'transparent',
          color: studyMode === 'word' ? 'white' : currentTheme.text,
          fontWeight: studyMode === 'word' ? '600' : '400',
        }}
      >
        📝 学单词
      </button>
      <button
        onClick={() => onSwitch('usage')}
        style={{
          ...baseButtonStyle,
          border: studyMode === 'usage' ? 'none' : `1px solid ${currentTheme.border}`,
          background: studyMode === 'usage' ? '#1890ff' : 'transparent',
          color: studyMode === 'usage' ? 'white' : currentTheme.text,
          fontWeight: studyMode === 'usage' ? '600' : '400',
        }}
      >
        💬 学用法
      </button>
      <button
        onClick={() => onSwitch('sentence')}
        style={{
          ...baseButtonStyle,
          border: studyMode === 'sentence' ? 'none' : `1px solid ${currentTheme.border}`,
          background: studyMode === 'sentence' ? '#1890ff' : 'transparent',
          color: studyMode === 'sentence' ? 'white' : currentTheme.text,
          fontWeight: studyMode === 'sentence' ? '600' : '400',
        }}
      >
        📖 学句子
      </button>
    </div>
  );
}

export default ModeSwitchButtons;
